/**
 * Set `data-theme` (and optional `data-layout` / `color-scheme`) on the document root.
 * Safe no-op during SSR. Backwards-compatible with single-argument `applyTheme(theme)`.
 */
export function applyTheme(theme, options) {
    if (typeof document === "undefined")
        return;
    const root = document.documentElement;
    root.dataset.theme = theme;
    // Sites that still style on `data-variant` (e.g. Franks) stay in sync with the theme.
    root.dataset.variant = theme;
    if (options?.layout !== undefined) {
        root.dataset.layout = options.layout;
    }
    if (options?.colorScheme) {
        root.style.colorScheme = options.colorScheme;
    }
}
//# sourceMappingURL=applyTheme.js.map